import {
  DYNAMIC_FRAME_REQUEST_END_EVENT,
  DYNAMIC_FRAME_REQUEST_START_EVENT,
} from '../../dynamic/frame/events.mjs'

export function useDynamicFrameLoading(button, setLoading) {
  if (button.dataset.dynamicFrameLoading === 'false') return () => {}

  const activeRequestIds = new Set()

  const startLoading = event => {
    if (event.target !== button) return

    activeRequestIds.add(event.detail.requestId)
    setLoading(true)
  }

  const finishLoading = event => {
    if (event.target !== button) return

    activeRequestIds.delete(event.detail.requestId)
    if (activeRequestIds.size === 0) setLoading(false)
  }

  button.addEventListener(DYNAMIC_FRAME_REQUEST_START_EVENT, startLoading)
  button.addEventListener(DYNAMIC_FRAME_REQUEST_END_EVENT, finishLoading)

  return () => {
    button.removeEventListener(DYNAMIC_FRAME_REQUEST_START_EVENT, startLoading)
    button.removeEventListener(DYNAMIC_FRAME_REQUEST_END_EVENT, finishLoading)
  }
}
